/**
 * Strips the UI-only `hasRemove` flag, leaving the fields the API consumes
 * (first_name, last_name, passenger_type).
 */
export function mapAirportBusPassengersForApi(passengerList: Array<any>) {
  return (Array.isArray(passengerList) ? passengerList : []).map(
    ({ hasRemove: _hasRemove, ...passenger }) => passenger
  );
}
